import { useDropzone } from 'react-dropzone';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { useAppState } from '../AppContext';

const FileUpload = ({ redirect, showFileTypeMessage, containerStyle }) => {
  const [{ fileList }, dispatch] = useAppState();

  //  const {acceptedFiles, getRootProps, getInputProps} = useDropzone();

  const baseStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: '5px',
    paddingLeft: '10px',
    paddingRight: '10px',
    borderWidth: 2,
    borderRadius: 2,
    borderColor: 'black',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: 'black',
    outline: 'none',
    transition: 'border .24s ease-in-out',
    lineHeight: '1.5em'
  };

  const activeStyle = {
    borderColor: '#2196f3'
  };

  const acceptStyle = {
    borderColor: '#00e676'
  };

  const rejectStyle = {
    borderColor: '#ff1744'
  };

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject
  } = useDropzone({
    accept: '.pdf,.doc,.docx',
    onDropAccepted: (files) => {
      console.log(files);
      dispatch({ type: 'SET_FILE_LIST', fileList: files });
      dispatch({ type: 'SET_UPLOAD_TITLE', uploadTitle: files[0].name });
    }
  });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {})
    }),
    [
      isDragActive,
      isDragReject,
      isDragAccept,
      acceptStyle,
      activeStyle,
      baseStyle,
      rejectStyle
    ]
  );

  const files = fileList.map((file) => <li key={file.path}>{file.path}</li>);

  return (
    <section className="container" style={{ ...containerStyle }}>
      <div {...getRootProps({ style })}>
        <input {...getInputProps()} />

        {files.length === 0 ? (
          <p>
            To upload, drag and drop some files here, or{' '}
            <b>click to select files</b>.
          </p>
        ) : (
          <ul>
            <aside>
              <h4>Files selected to upload</h4>
              <ul>{files}</ul>
            </aside>
            <br />
            <p>
              You can <i>replace</i> this with a new selection by dragging and
              drop some files here, or <b>clicking to select files</b>.
            </p>
            {redirect}
          </ul>
        )}
      </div>
      {showFileTypeMessage && (
        <small className={'text-muted form-text'}>
          You can upload document in either Word (.doc/.docx) or PDF format.
        </small>
      )}
    </section>
  );
};

FileUpload.propTypes = {
  containerStyle: PropTypes.object,
  redirect: PropTypes.object, // A JSX fragment
  showFileTypeMessage: PropTypes.bool
};
export default FileUpload;
